/*
  File name: helpers.js
    Program Description:
    - This file exports all generic helper functions that can be used within the
    components
*/

// Required to run the code for number to words
/* eslint-disable no-useless-escape */
// Required to run the code for number to words
/* eslint-disable eqeqeq */
import store from '@/store'
import * as html2pdf from 'html2pdf.js'

export const convertObjId = (objectId, schema) => {
  objectId && objectId.forEach((item) => {
    let key = item
    let value = '_id'
    if (typeof item === 'object') {
      key = Object.keys(item)[0]
      value = item[`${key}`]
    }

    if (schema[`${key}`]) {
      if (Array.isArray(schema[`${key}`])) {
        schema[`${key}`] = schema[`${key}`].map(x => (x[`${value}`] || x.id || x))
      } else if (schema[`${key}`][`${value}`]) schema[`${key}`] = schema[`${key}`][`${value}`]
    }
  })
}

export const pluralize = (vm, count, collection) => {
  let label = collection
  let suffix = ''
  if (collection.endsWith('s')) {
    suffix = ''
  } else if (collection.endsWith('e')) {
    suffix = 's'
  } else {
    suffix = 'es'
  }
  if (count > 1) {
    if (vm.$pluralize) label = vm.$pluralize(collection)
    else label = `${collection}${suffix}`
  }
  return label
}

export const capitalize = (value, isCamelCase = false) => {
  if (value) {
    if (isCamelCase) {
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
    return `${value.charAt(0).toUpperCase()}${value.slice(1).toLowerCase()}`
  }

  return ''
}

export function getFullName (data, empty = '') {
  const middleName = data.middleName ? `${data.middleName} ` : ''
  const suffix = data.suffix ? ` ${data.suffix}` : ''
  if (data.firstName) return `${data.firstName} ${middleName}${data.lastName}${suffix}`
  else return empty
}

export const downloadFile = (blob, name) => {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.download = name
  document.body.appendChild(link)
  link.click()
  window.URL.revokeObjectURL(url)
  link.parentNode.removeChild(link)
}

export const convertToTSV = (arr) => {
  if (arr.length === 0 || arr[0] === undefined) return 'No such report found.'
  const headers = [...arr].sort((a, b) => Object.keys(a).length - Object.keys(b).length).reverse()
  const array = [Object.keys(headers[0])].concat(arr)
  return array.map(it => Object.values(it).join('\t').toString()).join('\n')
}

export const dataURLToFile = (url, filename, mimeType) => {
  const file = fetch(url).then((res) => {
    return res.arrayBuffer()
  }).then((buf) => {
    return new File([buf], filename, { type: mimeType })
  })
  return file
}

export const uploadNestedForm = (data, nestedSchema = []) => {
  const form = new FormData()
  Object.entries(data).forEach(([key, value]) => {
    if (Array.isArray(value) && !nestedSchema.includes(key)) {
      value.forEach((entry) => {
        form.append(key, entry)
      })
    }
    if (nestedSchema.includes(key)) {
      form.append(key, JSON.stringify(value))
    } else {
      form.append(key, value)
    }
  })
  return form
}

export async function fileUploadForm (formParams) {
  const form = new FormData()
  Object.keys(formParams.fields).forEach(key => {
    if (Array.isArray(formParams.fields[`${key}`])) {
      formParams.fields[`${key}`].forEach(el => {
        form.append(key, el)
      })
    } else {
      form.append(key, formParams.fields[`${key}`])
    }
  })
  return form
}

export function uploadID (key, data) {
  const form = new FormData()
  form.append(`idPicture.${key}`, data)
  return form
}

export function toDateString (dt) {
  let date = new Date()
  if (dt && dt !== '') date = new Date(dt)
  return `${monthName(date.getMonth())} ${date.getDate()}, ${date.getFullYear()}`
}

export function monthName (i) {
  const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December']
  return monthNames[`${i}`]
}

export function getScYr (dt) {
  let date = new Date()
  if (dt && dt !== '') date = new Date(dt)

  const year = date.getFullYear()
  if (date.getMonth() < 8) return `SY ${year - 1} - ${year}` // august
  else return `SY ${year} - ${year + 1}`
}

export function dateAndTimeCreated (date) {
  const d = new Date(date)
  return `${d.toLocaleDateString('en-US')} ${d.toLocaleTimeString('en-US')}`
}

export function avgCharacter (arr) {
  if (!arr || !arr.length) return ''
  const behavior = store.state.defaults.behavior
  const sorted = [...arr].sort((a, b) => behavior.indexOf(a) - behavior.indexOf(b))
    .map((i) => {
      return {
        char: i.split('-')[0],
        int: arr.filter((a) => a === i).length
      }
    })
  return sorted.find((i) => i.int === Math.max(...sorted.map((i) => i.int))).char
}

export function html2Pdf (element, opt) {
  html2pdf().from(element).set(opt).toPdf().get('pdf').then(function (pdf) {
    const totalPages = pdf.internal.getNumberOfPages()
    for (let i = 1; i <= totalPages; i++) {
      pdf.setPage(i)
      pdf.setFontSize(9)
      pdf.text(`Page ${i} of ${totalPages}`, (pdf.internal.pageSize.getWidth()) - 120, pdf.internal.pageSize.getHeight() - 40)
      // to change value on footer for dynamic
      pdf.text('BAR-TCD OP-01F6', 90, pdf.internal.pageSize.getHeight() - 40)
      pdf.text('Revision: 0', 90, pdf.internal.pageSize.getHeight() - 30)
    }

    // eslint-disable-next-line security/detect-non-literal-fs-filename
    window.open(pdf.output('bloburl'), '_blank')
  })
}

export function encodeReqQuery (query) {
  const keys = Object.keys(query)
  const req = keys
    .filter((k) => query[`${k}`])
    .reduce((acc, curr, i) => curr ? `${acc}${curr}=${query[`${curr}`]}&` : acc, '?')
  return encodeURI(req)
}

export function addDaysToDate (date, days) {
  const result = new Date(date)
  result.setDate(result.getDate() + days)
  const newDate = new Date(result)
  return newDate.toISOString()
}

export function datesAreEqual (dateCreated, dateUpdated) {
  if (dateCreated === dateUpdated) {
    return true
  }

  return false
}

export function fullName (salutation = '', firstName, middleName = '', lastName, suffix = '') {
  const name = `${salutation} ${firstName} ${middleName} ${lastName} ${suffix}`

  return name.replace(/\s{2,}/g, ' ')
}

export function isNumber (e) {
  const char = String.fromCharCode(e.keyCode)

  if (/^[0-9]+$/.test(char)) {
    return true
  } else {
    e.preventDefault()
  }
}

export function sortAlphaNumeric (array) {
  const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' })

  return array.sort(collator.compare)
}

export function colsValue (total) {
  if (total.length < 15) {
    return 2
  } else if (total.length < 18) {
    return 3
  }

  return 4
}

export function toLocaleString (value) {
  return value.toLocaleString('en-US', { style: 'currency', currency: 'PHP' })
}

export function toCamelCase (str) {
  const words = str.split(' ')
  words[0] = words[0].toLowerCase()
  let strCamelCase = ''

  for (const word of words) {
    strCamelCase = strCamelCase.concat(word)
  }

  return strCamelCase
}

// export function convertToCurrency (value) {
//   const result = value.replace(/,/g, '')
//   const parts = result.toString().split('.')
//   parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
//   return parts.join('.')
// }

export function toPhilippinePeso (value) {
  return new Intl.NumberFormat('fil-PH', { style: 'currency', currency: 'PHP' }).format(value)
}

export const wordsToCamelCased = (str = '') => str.replace(/[A-Z]/g, words => words.toLowerCase())
  .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => index === 0
    ? word.toLowerCase()
    : word.toUpperCase()).replace(/[\s,/-]+/g, '')

export function titleEllipsis (title) {
  const titleLength = title.length
  const titleArray = title.split(' ')
  const newTitleArray = []

  titleArray.forEach(title => {
    newTitleArray.push({
      title,
      titleLength: title.length
    })
  })

  if (titleLength > 60) {
    let num = 0
    const mapNewArray = newTitleArray.map((newTitle) => {
      if (num + newTitle.titleLength <= 60) {
        num += newTitle.titleLength
        return newTitle.title
      }
    })

    mapNewArray.pop()

    return mapNewArray.join(' ').trim() + '...'
  }

  return title
}

export const waitForElement = (selector) => {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelectorAll(selector))
    }
    const observer = new MutationObserver(mutations => {
      if (document.querySelector(selector)) {
        resolve(document.querySelectorAll(selector))
        observer.disconnect()
      }
    })
    observer.observe(document.body, {
      childList: true,
      subtree: true
    })
  })
}

export const toOrdinal = (_number) => {
  const number = parseInt(_number)
  const j = number % 10
  const k = number % 100
  if (j == 1 && k != 11) return `(${number}st)`
  if (j == 2 && k != 12) return `(${number}nd)`
  if (j == 3 && k != 13) return `(${number}rd)`
  return `(${number}th)`
}

const thVal = {
  uppercased: ['', 'THOUSAND', 'MILLION', 'BILLION', 'TRILLION'],
  lowercased: ['', 'thousand', 'million', 'billion', 'trillion']
}
const dgVal = {
  uppercased: ['ZERO', 'ONE', 'TWO', 'THREE', 'FOUR', 'FIVE', 'SIX', 'SEVEN', 'EIGHT', 'NINE'],
  lowercased: ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine']
}
const tnVal = {
  uppercased: ['TEN', 'ELEVEN', 'TWELVE', 'THIRTEEN', 'FOURTEEN', 'FIFTEEN', 'SIXTEEN', 'SEVENTEEN', 'EIGHTEEN', 'NINETEEN'],
  lowercased: ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen']
}
const twVal = {
  uppercased: ['TWENTY', 'THIRTY', 'FORTY', 'FIFTY', 'SIXTY', 'SEVENTY', 'EIGHTY', 'NINETY'],
  lowercased: ['twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety']
}

export function numberToWords (s, caps = 'uppercased') {
  s = s.toString()
  s = s.replace(/[\, ]/g, '')
  if (s != parseFloat(s)) { return 'not a number ' }
  let xVal = s.indexOf('.')
  if (xVal == -1) { xVal = s.length }
  if (xVal > 15) { return 'too big' }
  const nVal = s.split('')
  let strVal = ''
  let skVal = 0
  for (let i = 0; i < xVal; i++) {
    if ((xVal - i) % 3 == 2) {
      if (nVal[`${i}`] == '1') {
        strVal += tnVal[`${caps}`][Number(nVal[i + 1])] + ' '
        i++
        skVal = 1
      } else if (nVal[`${i}`] != 0) {
        strVal += twVal[`${caps}`][nVal[`${i}`] - 2] + ' '
        skVal = 1
      }
    } else if (nVal[`${i}`] != 0) {
      strVal += dgVal[`${caps}`][nVal[`${i}`]] + ' '
      if ((xVal - i) % 3 == 0) { strVal += caps === 'uppercased' ? 'HUNDRED ' : 'hundred ' }
      skVal = 1
    }
    if ((xVal - i) % 3 == 1) {
      if (skVal) { strVal += thVal[`${caps}`][(xVal - i - 1) / 3] + ' ' }
      skVal = 0
    }
  }
  if (xVal != s.length) {
    strVal += caps === 'uppercased' ? 'PESOS AND ' : 'Pesos and '
    strVal += s.substring(s.indexOf('.') + 1, s.length) + (caps === 'uppercased' ? '/100 ONLY' : '/100 only')
  }
  // return strVal.replace(/\s+/g, ' ')
  return strVal.includes('PESOS') ? strVal.replace(/\s+/g, ' ') : `${strVal.replace(/\s+/g, ' ')}`
}
